module.exports = __webpack_public_path__ + "img/app-store-badge-downloads.796ee883.svg";